import {
  ObjectIdAsHexString,
  Collector,
} from "kreate-common/modules/business-types";
import { z } from "zod";

export const Params = z
  .object({
    artworkId: ObjectIdAsHexString.optional(),
    collectionId: ObjectIdAsHexString.optional(),
    userId: ObjectIdAsHexString.optional(),
    assetId: z.string().optional(),
    limit: z.coerce.number().optional(),
    offset: z.coerce.number().optional(),
  })
  .refine(
    (data) =>
      !!data.artworkId ||
      !!data.collectionId ||
      !!data.userId ||
      !!data.assetId,
    {
      message: "Required artworkId or collectionId or userId or assetId",
    }
  );

export type Params = z.infer<typeof Params>;

export const Result = z.object({
  collectors: Collector.array(),
  count: z.number(),
});

export type Result = z.infer<typeof Result>;

export const GetCollectors$Params = Params;
export type GetCollectors$Params = Params;
export const GetCollectors$Result = Result;
export type GetCollectors$Result = Result;
